import React, { useState } from 'react';
import { Alert, Flex } from 'antd';
import Button from '@client/components/Button';
import showSuccessNotification from '@client/utils/showSuccessNotification';
import showErrorNotification from '@client/utils/showErrorNotification';
import { getFullFleetExport } from '@client/lib/api';

const AlbaSettings = () => {
	const [exportStarted, setExportStarted] = useState(false);

	const onExport = async () => {
		try {
			getFullFleetExport();
			showSuccessNotification(
				'Export has started',
				'The result will be sent to your email once finished',
			);
			setExportStarted(true);
		} catch (e) {
			showErrorNotification(
				'Could not start export',
				e as Error,
			);
		}
	};

	return (
		<Flex 
			gap={16} 
			vertical
			style={{ width: 600 }}
		>
			{exportStarted && (
				<Alert
					message="Export started"
					description={`Generating the David Sheet may take up to 10 minutes. 
					The sheet will be sent to your accounts email once completed. It is safe to leave this page`}
					type="info"
					showIcon
				/>
			)}
			<Button
				style={{ width: 300 }}
				onClick={onExport}
				type="primary"
				disabled={exportStarted}
			>
				Export David Sheet
			</Button>
		</Flex>
	);
};

export default AlbaSettings;
